import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { TableHead, TableHeader, TableRow } from "@/components/ui/table";
import type { AssetsSortConfig } from "@/hooks/useAssetsUnifiedData";

interface AssetsTableHeaderProps {
  isAllSelected: boolean;
  isIndeterminate: boolean;
  onSelectAll: (checked: boolean) => void;
  onSort: (field: AssetsSortConfig['field']) => void;
  getSortIcon: (field: AssetsSortConfig['field']) => React.ReactNode;
}

export const AssetsTableHeader: React.FC<AssetsTableHeaderProps> = ({
  isAllSelected,
  isIndeterminate,
  onSelectAll,
  onSort,
  getSortIcon
}) => {
  return (
    <TableHeader>
      <TableRow>
        <TableHead className="w-10 pl-2 pr-1 py-1 sticky z-10 bg-muted/60 h-8 sm:w-12 sm:pl-3 sm:pr-2">
          <div className="h-8 flex items-center justify-center">
            <Checkbox
              checked={isAllSelected}
              onCheckedChange={onSelectAll}
              aria-label="Select all assets"
              className="h-3.5 w-3.5 data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground"
              {...(isIndeterminate && { 'data-state': 'indeterminate' })}
            />
          </div>
        </TableHead>
        <TableHead
          className="text-left sticky z-10 bg-muted/60 h-8 px-2 py-1 text-xs font-medium text-muted-foreground select-none cursor-pointer transition-colors hover:bg-muted/70"
          onClick={() => onSort('asset_name')}
        >
          <div className="flex items-center gap-1 pl-9 sm:pl-10">
            <span>Asset</span>
            {getSortIcon('asset_name')}
          </div>
        </TableHead>
        <TableHead
          className="w-12 px-2 py-1 text-center sticky z-10 bg-muted/60 h-8 text-xs font-medium text-muted-foreground select-none cursor-pointer transition-colors hover:bg-muted/70"
          onClick={() => onSort('source_type')}
        >
          <div className="flex items-center gap-1 justify-center">
            <span>Source</span>
            {getSortIcon('source_type')}
          </div>
        </TableHead>
        <TableHead className="text-left sticky z-10 bg-muted/60 h-8 px-3 py-1 text-xs font-medium text-muted-foreground">Account</TableHead>
        <TableHead
          className="w-16 px-2 py-1 text-center sticky z-10 bg-muted/60 h-8 text-xs font-medium text-muted-foreground select-none cursor-pointer transition-colors hover:bg-muted/70"
          onClick={() => onSort('currency')}
        >
          <div className="flex items-center gap-1 justify-center">
            <span>Currency</span>
            {getSortIcon('currency')}
          </div>
        </TableHead>
        <TableHead
          className="sticky z-10 bg-muted/60 h-8 px-3 py-1 text-xs font-medium text-muted-foreground text-right select-none cursor-pointer transition-colors hover:bg-muted/70"
          onClick={() => onSort('market_value')}
        >
          <div className="flex items-center gap-1 justify-end">
            <span>Value</span>
            {getSortIcon('market_value')}
          </div>
        </TableHead>
        <TableHead className="w-12 px-2 py-1 text-right sticky z-10 bg-muted/60 h-8"></TableHead>
      </TableRow>
    </TableHeader>
  );
};
